var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3333H18.3333V5H5V18.3333ZM8.33333 8.33333H15V15H8.33333V8.33333ZM5 35H18.3333V21.6667H5V35ZM8.33333 25H15V31.6667H8.33333V25ZM21.6667 5V18.3333H35V5H21.6667ZM31.6667 15H25V8.33333H31.6667V15ZM21.6833 21.6667H25.0167V25H21.6833V21.6667ZM25.0167 25H28.35V28.3333H25.0167V25ZM21.6833 28.3333H25.0167V31.6667H21.6833V28.3333ZM28.35 28.3333H31.6833V31.6667H28.35V28.3333ZM31.6833 31.6667H35.0167V35H31.6833V31.6667ZM25.0167 31.6667H28.35V35H25.0167V31.6667ZM28.35 21.6667H31.6833V25H28.35V21.6667ZM31.6833 25H35.0167V28.3333H31.6833V25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxQr);
export default __webpack_public_path__ + "static/media/bx_qr.f73c052ee1d103028c08a363e13f5c23.svg";
export { ForwardRef as ReactComponent };